/* eslint-disable */
import React, { Fragment, useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { useToken } from "src/components/authentication/TokenProvider";
import { ContextSetting } from "src/context/ContextSetting";
import { ContextUser } from "src/context/ContextUser";
import { Graphql } from "src/graphql/_graphql";
import { BrowserRouter as Router } from "react-router-dom";
import { LightCleanAdminVerify } from "./LightCleanAdminVerify";
import { AppRoute } from "./AppRoute";
import { PolarisProvider } from "./provider/PolarisProvider";
import { Supplier, useSupplierAdminLazyQuery, useSupplierOrderCountByStatusQuery } from "src/graphql/codegen_graphql";
import { ToggleProvider } from "./provider/ToggleProvider";
import { SellerMenuProvider } from "./provider/SellerMenuProvider";
import { ProgramBrochure } from "src/screens/other/program-brochure";

export function AppSupplier() {
  const { data, loading, error } = useQuery(Graphql.Query.QUERY_MERCHANT);
  const [supplierAdmin] = useSupplierAdminLazyQuery();
  const [supplier, setSupplier] = useState<Supplier | null>(null);
  const { token, setToken } = useToken();
  const queryOrderCount = useSupplierOrderCountByStatusQuery();

  if (data && (!data.merchant || data.merchant?.id === null)) {
    if (token) {
      setToken(null);
    }
  }

  useEffect(() => {
    if (data && data.merchant) {
      const x: any[] = JSON.parse(localStorage.getItem("recent_logins") || "[]");
      if (x.find((f) => f.id === data.merchant.id)) {
        if (x.length > 3) {
          x.splice(0, 1);
        }
        x.push({
          id: data.merchant.id,
          name: data.merchant.name,
          logo: data.merchant.logo,
          username: data.merchant.name,
          by: "TOKEN",
          secret: token?.substring(2, token.length),
        });
      }

      localStorage.setItem("recent_logins", JSON.parse(x as any));
    }
  }, []);

  useEffect(() => {
    if (data && data.merchant) {
      if (!supplier) {
        supplierAdmin({
          variables: {
            supplierId: Number(data.merchant.id),
          },
        }).then((res) => {
          setSupplier(res.data?.supplier ?? null);
        });
      }
    }
  }, [data, supplier]);

  useEffect(() => {
    if (error) {
      console.log("Error:" + error.message);
    }
  }, [error]);

  const orderCount = queryOrderCount.data?.supplierOrderCountByStatus;

  const count = queryOrderCount.data ? Object.values(orderCount).reduce((a: number, b: any) => a + b, 0) : 0;

  return (
    <Fragment>
      <LightCleanAdminVerify verified={!loading} />
      {!loading && (
        <ContextUser.Provider value={{ merchant: { ...data?.merchant, ...orderCount, supplier, orderCount: count } }}>
          <ContextSetting.Provider
            value={{ supplierSetting: { ...data?.supplierSetting, ...data?.supplierSettingList } }}
          >
            {data && data.merchant && data.merchant.paidRegister === false ? (
              <ProgramBrochure />
            ) : (
              <SellerMenuProvider>
                <Router>
                  <ToggleProvider>
                    <PolarisProvider>
                      <AppRoute />
                    </PolarisProvider>
                  </ToggleProvider>
                </Router>
              </SellerMenuProvider>
            )}
          </ContextSetting.Provider>
        </ContextUser.Provider>
      )}
    </Fragment>
  );
}
